"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterMobileBox = exports.StyledLayout = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledLayout = (0, styled_components_1.default)(general_1.Flexbox) `
  ${(props) => {
    const { isMenuExpanded, hasSidebar, hasFilter, hasHeader, hasTabs } = props;
    const getPaddingTop = () => {
        var _a;
        const paddingValues = [
            { condition: !hasHeader, value: '0' },
            { condition: hasTabs && hasSidebar, value: '6.85rem' },
            { condition: hasSidebar && !hasTabs, value: '5rem' },
            { condition: !hasSidebar && hasTabs, value: '6.85rem' },
            { condition: !hasSidebar && !hasTabs, value: '5rem' },
        ];
        const { value } = (_a = paddingValues.find(({ condition }) => condition)) !== null && _a !== void 0 ? _a : { value: '0' };
        return value;
    };
    return (0, styled_components_1.css) `
    background-color: ${theme_1.grayScale[100]};
    width: 100vw;
    max-width: 100vw;
    overflow-x: hidden;
    max-height: 100vh;
    overflow-y: auto;
    transition: all 0.3s ease;
    position: relative;
    padding: ${hasHeader ? '5rem' : 0} ${hasFilter ? '332px' : 0} 0 ${hasSidebar ? (isMenuExpanded ? '204px' : '80px') : 0};
    align-items: flex-start;
    justify-content: flex-start;

    div[aria-label='header-component'] {
      transition: all 0.3s ease;
      width: ${hasSidebar
        ? isMenuExpanded
            ? 'calc(100vw - 204px)'
            : 'calc(100vw - 80px)'
        : '100vw'};
      position: fixed;
      top: 0;
      right: 0;

      @media (max-width: 883px) {
        width: 100vw;
      }
    }

    @media (min-width: 1440px) {
      div[aria-label='layout-content']>div[aria-label="container"]:first-of-type {
        width: 100% ;
        max-width: 1440px;
      }
    }

    @media (max-width: 883px) {
      padding: ${getPaddingTop()} 0 0 0;
      max-height: ${hasSidebar ? 'calc(100vh - 125px)' : hasFilter ? 'calc(100vh - 20px)' : '100vh'}} ;
    }
   ${hasHeader &&
        (0, styled_components_1.css) `
       div[aria-label='layout-content'] {
         position: relative;
         &:after {
           content: '';
           position: fixed;
           top: 70px;
           left: 0;
           width: 100%;
           height: 10px;
           background: linear-gradient(
             180deg,
             rgba(87, 96, 102, 0.1) 0%,
             rgba(87, 96, 102, 0) 100%
           );
         }
       }
     `}
   
  `;
}}
  div[aria-label='layout-content'] {
    @media (min-width: 376px) {
      padding-inline: ${theme_1.paddings.dashboard.desktop.inline};
      padding-block: ${theme_1.paddings.dashboard.desktop.block};
    }
    @media (max-width: 375px) {
      padding-inline: ${theme_1.paddings.dashboard.mobile.inline};
      padding-block: ${theme_1.paddings.dashboard.mobile.block};
    }
  }
`;
exports.StyledFilterMobileBox = (0, styled_components_1.default)(general_1.Paper) `
  ${({ hasSidebar, isOpenFilter }) => (0, styled_components_1.css) `
    position: fixed;
    bottom: ${hasSidebar ? '185px' : '85px'};
    right: 20px;
    background: ${isOpenFilter ? theme_1.grayScale[50] : 'transparent'};
    width: 380px;
    max-height: ${isOpenFilter ? '65vh' : 0};
    overflow-x: hidden;
    overflow-y: auto;
    transition: all 0.3s ease;
    z-index: 190;
    justify-content: flex-start;
    align-items: center;
    transition: all 0.3s ease;

    & div[aria-label='text-field-wrapper'] {
      margin-bottom: -32px;
    }

    @media (min-width: 884px) {
      display: none;
    }
    @media (max-width: 411px) {
      width: 100vw;
      right: 0;
    }
  `}
`;
//# sourceMappingURL=styles.js.map